import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';

interface HeaderProps {}

const batchTicketRedeemDetailsTableHead = [
  { title: 'Conta sinacor' },
  { title: 'Cliente', flex: 1.5 },
  { title: 'Produto' },
  { title: 'Ativo', flex: 1.5 },
  { title: 'Valor da boleta' },
  // { title: 'Valor liq. estimado' },
  { title: 'Status' },
  { title: '', flex: 0.5 },
];

export const Header: React.FC<HeaderProps> = () => {
  return (
    <TableHeadContainer px={Spacing['stack.xxxs']}>
      {batchTicketRedeemDetailsTableHead.map((item, index) => (
        <TableHeadItem key={`${item.title}-${index}`} {...item} />
      ))}
    </TableHeadContainer>
  );
};
